import { z } from 'zod';

import {
  DefaultPasswordPolicyMessages,
  PasswordPolicyRules,
  type PasswordPolicyMessages,
} from './password-policy-rules';

export function isPasswordValid(password: string): boolean {
  return PasswordPolicyRules.every(rule => rule.test(password));
}

export function createPasswordSchema(
  messages: Partial<PasswordPolicyMessages> = {},
) {
  const m = { ...DefaultPasswordPolicyMessages, ...messages };

  return z
    .string()
    .min(8, m.minLength)
    .regex(/\d/u, m.number)
    .regex(/[^A-Za-z0-9]/u, m.special)
    .regex(/[A-Z]/u, m.uppercase)
    .regex(/[a-z]/u, m.lowercase);
}
